import axios from 'axios'

function request(data, methods = "get", file = "robot_new.php") {
    let userid = localStorage.getItem("userid");
    let member_userid = localStorage.getItem("member_userid");
    let platform = localStorage.getItem("platform");
    let isTest = localStorage.getItem("isTest");
    let appid = localStorage.getItem("appid");

    if (isTest) data.is_test = isTest;
    data.userid = userid ? userid : "";//携带userid传递给后端
    data.member_userid = member_userid ? member_userid : "";//携带member_userid传递给后端
    if (platform) data.platform = platform;
    if (appid) data.appid = appid;

    if(data.action=="reply"){ 
        // console.log("hhhhhhhhhhhhh",window.location.search)
        let prams = new URLSearchParams(window.location.search) 
        if(prams.get("v")!=null){
            data.v=prams.get("v");
        } 
        if(prams.get("source")!=null){
            console.log("source参数",prams.get("source"))
            data.source=prams.get("source");
        } 
    }


    // let url = `njapi/smartprogram/${file}`;    //测试
    let url = `szapi/smartprogram/${file}`;    //正式
    return new Promise((resolve, reject) => {
        if (methods === "get") {
            // get 请求
            axios({
                methods: methods,		//请求方式，默认为‘get’ ，可省略
                url: url,		//请求的接口网址
                params: data,
                timeout:60000
            }).then(res => {
                resolve(res);
            }).catch((err) => {
                reject(err);
            })
        } else {
            // post 请求
            axios({
                headers: { "Content-Type": "multipart/form-data" },
                method: 'post',
                url: url,
                data: data,
                timeout:60000
            }).then(res => {
                resolve(res);
            }).catch((err) => {
                reject(err);
            })
        }
    })
}


export function requestQyWeixin(config) {
    // const baseURL = 'https://hkgw.bendibao.com/weixin_work_api/qywechat/api/v1/' //测试服
    const baseURL = 'https://dgapi.bendibao.com/weixin_work/qywechat/api/v1/'//正式服

    const instance = axios.create({
        baseURL: baseURL,
        timeout: 100000,
        headers: {
            // RequestHeader: "Bearer " + localStorage.authorization,
            // RequestUser: localStorage.userid_h5,
            // RequestQy: localStorage.qy_id_h5,
            'X-Requested-With': 'XMLHttpRequest',
            'Cache-Control': 'no-cache'
        },
    })

    return instance(config);
}



const service = {
    get(url, params) {
        const config = {
            method: "get",
            url: url,
            params: Date.parse(new Date()),
        };
        if (params) config.params = params;
        return request(config);
    },
    post(url, params) {
        const config = {
            method: "post",
            url: url,
        };
        if (params) config.data = params;
        return request(config);
    },
    put(url, params) {
        const config = {
            method: "put",
            url: url,
        };
        if (params) config.params = params;
        return request(config);
    },
};


function getNowDateTime() {
    let dateTime = new Date();
    let Y = dateTime.getFullYear();
    let M = (dateTime.getMonth() + 1).toString().padStart(2, "0");
    let D = dateTime.getDate().toString().padStart(2, "0");
    let h = dateTime.getHours().toString().padStart(2, "0");
    let m = dateTime.getMinutes().toString().padStart(2, "0");

    return `${Y}-${M}-${D} ${h}:${m}`

}



export default {
    request,
    getNowDateTime
} 